module.exports = {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }